import * as $ from 'jquery';
import moment from 'moment';
import { addDatePicker, addDateTimePicker } from '../../services/datepicker';

export default function loadDatePickers(): void {
    addDatePicker($('.datepicker'), { minimum: moment().startOf('day') });
    addDateTimePicker($('.datetimepicker'), { minimum: moment() });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/datepicker.ts